import React from 'react'

import { Maybe } from 'generated-graphql/graphql'

import { FifthActiveCenterSvg } from './background/FifthActiveCenterSvg'
import { FifthActiveLeftSvg } from './background/FifthActiveLeftSvg'
import { FifthActiveRightSvg } from './background/FifthActiveRightSvg'
import { FifthDefaultCenterSvg } from './background/FifthDefaultCenterSvg'
import { FifthDefaultLeftSvg } from './background/FifthDefaultLeftSvg'
import { FifthDefaultRightSvg } from './background/FifthDefaultRightSvg'
import { FirstActiveCenterSvg } from './background/FirstActiveCenterSvg'
import { FirstActiveLeftSvg } from './background/FirstActiveLeftSvg'
import { FirstActiveRightSvg } from './background/FirstActiveRightSvg'
import { FirstDefaultCenterSvg } from './background/FirstDefaultCenterSvg'
import { FirstDefaultLeftSvg } from './background/FirstDefaultLeftSvg'
import { FirstDefaultRightSvg } from './background/FirstDefaultRightSvg'
import { FourthActiveCenterSvg } from './background/FourthActiveCenterSvg'
import { FourthActiveLeftSvg } from './background/FourthActiveLeftSvg'
import { FourthActiveRightSvg } from './background/FourthActiveRightSvg'
import { FourthDefaultCenterSvg } from './background/FourthDefaultCenterSvg'
import { FourthDefaultLeftSvg } from './background/FourthDefaultLeftSvg'
import { FourthDefaultRightSvg } from './background/FourthDefaultRightSvg'
import { SecondActiveCenterSvg } from './background/SecondActiveCenterSvg'
import { SecondActiveLeftSvg } from './background/SecondActiveLeftSvg'
import { SecondActiveRightSvg } from './background/SecondActiveRightSvg'
import { SecondDefaultCenterSvg } from './background/SecondDefaultCenterSvg'
import { SecondDefaultLeftSvg } from './background/SecondDefaultLeftSvg'
import { SecondDefaultRightSvg } from './background/SecondDefaultRightSvg'
import { ThirdActiveCenterSvg } from './background/ThirdActiveCenterSvg'
import { ThirdActiveLeftSvg } from './background/ThirdActiveLeftSvg'
import { ThirdActiveRightSvg } from './background/ThirdActiveRightSvg'
import { ThirdDefaultCenterSvg } from './background/ThirdDefaultCenterSvg'
import { ThirdDefaultLeftSvg } from './background/ThirdDefaultLeftSvg'
import { ThirdDefaultRightSvg } from './background/ThirdDefaultRightSvg'
import { Position, TagTypes } from './Tag.types'

export const findTagPart = (
  type: TagTypes,
  position: Position,
  match?: Maybe<boolean>
) => {
  switch (type) {
    case 0:
      switch (position) {
        case 'left':
          if (match) {
            return <FirstActiveLeftSvg />
          }
          return <FirstDefaultLeftSvg />
        case 'right':
          if (match) {
            return <FirstActiveRightSvg />
          }
          return <FirstDefaultRightSvg />
        default:
          if (match) {
            return <FirstActiveCenterSvg />
          }
          return <FirstDefaultCenterSvg />
      }
    case 1:
      switch (position) {
        case 'left':
          if (match) {
            return <SecondActiveLeftSvg />
          }
          return <SecondDefaultLeftSvg />
        case 'right':
          if (match) {
            return <SecondActiveRightSvg />
          }
          return <SecondDefaultRightSvg />
        default:
          if (match) {
            return <SecondActiveCenterSvg />
          }
          return <SecondDefaultCenterSvg />
      }

    case 2:
      switch (position) {
        case 'left':
          if (match) {
            return <ThirdActiveLeftSvg />
          }
          return <ThirdDefaultLeftSvg />
        case 'right':
          if (match) {
            return <ThirdActiveRightSvg />
          }
          return <ThirdDefaultRightSvg />
        default:
          if (match) {
            return <ThirdActiveCenterSvg />
          }
          return <ThirdDefaultCenterSvg />
      }

    case 3:
      switch (position) {
        case 'left':
          if (match) {
            return <FourthActiveLeftSvg />
          }
          return <FourthDefaultLeftSvg />
        case 'right':
          if (match) {
            return <FourthActiveRightSvg />
          }
          return <FourthDefaultRightSvg />
        default:
          if (match) {
            return <FourthActiveCenterSvg />
          }
          return <FourthDefaultCenterSvg />
      }

    case 4:
      switch (position) {
        case 'left':
          if (match) {
            return <FifthActiveLeftSvg />
          }
          return <FifthDefaultLeftSvg />
        case 'right':
          if (match) {
            return <FifthActiveRightSvg />
          }
          return <FifthDefaultRightSvg />
        default:
          if (match) {
            return <FifthActiveCenterSvg />
          }
          return <FifthDefaultCenterSvg />
      }
  }
}
